<template>
<div class='main'>
  <div class="bg"
       :style='`width:${800*$store.state.ratio.width}px;height:${600*$store.state.ratio.height}px`'>
    <div class="title"
         :style='`font-size:${20*$store.state.ratio.width}px;top:${30*$store.state.ratio.height}px;left:${20*$store.state.ratio.width}px`'>各地区扶贫人口分布</div>
    <img src="../../../assets/imgs/sgz.png"
         alt="点击显示大图" @click="showBigImg">
         </div>
             <yinjiangMap  :data='data'  ref='sgzMap'/> 

</div>
</template>

<script>
import yinjiangMap from '../components/yinjiangMap.vue'

export default {
  components:{
  yinjiangMap
  },
  props: ['data'],
    data(){
    return{
       mapNumber:0,
    }
   
  },
methods:{
  showBigImg(){
    this.$refs.sgzMap.init()
  },

}
}
</script>

<style lang="scss"  scoped>
.main{
  z-index:20003;

.bg {
  background: #0d1b35;
  position: relative;
  img {
    margin-top: 10px;
    width: 95%;
    height: 98%;
    background-color: #0d1b35;
  }
  .title {
    background: #0d1b35;
    color: yellow;
    position: absolute;
  }
}
}

</style>